<template>
  <div class="estimate-bubble">
    <BubbleHeader>{{message.message_description}}</BubbleHeader>
    <template v-if="$hasPermission('can_view_payments')">
      <BubbleTextRow v-if="message.text"><BubbleTextMsg :text="message.text" /></BubbleTextRow>
      
      <MsgblContent :type="message.direction" v-if="message.showEntityLink">
        <FrontageLink to="app.estimate.show" :params="{uid: estimate.uid}" >
          <MsgblLinkHeader icon="estimate" 
                          :title="message.appointment_title" />
        </FrontageLink>
      </MsgblContent>

      <MsgblContent :type="message.direction" v-if="message.showEntityCard">
        <FrontageLink to="app.estimate.show" :params="{uid: estimate.uid}" >
          <MsgblLinkHeader icon="estimate" 
                          :title="message.appointment_title" />
        </FrontageLink>

        <MsgblTextRow class="estimate-for" v-if="estimate.invoice_for">
          <MsgblTextLabel>{{$t('payment.info.for')}}:</MsgblTextLabel>
          <MsgblTextValue>{{estimate.invoice_for}}</MsgblTextValue>
        </MsgblTextRow>

        <MsgblTextRow class="estimate-amount" v-if="estimate.amount_h">
          <MsgblTextLabel>{{$t('payment.info.grand_total')}}:</MsgblTextLabel>
          <MsgblTextValue>{{estimate.amount_h}}</MsgblTextValue>
        </MsgblTextRow>

        <MsgblTextRow class="estimate-amount" v-if="estimate.due_date">
          <MsgblTextLabel>{{$t('payment.estimate.expiration_date')}}:</MsgblTextLabel>
          <MsgblTextValue>{{estimate.due_date}}</MsgblTextValue>
        </MsgblTextRow>

        <MsgblActions v-if="estimate.estimate_actions" 
                      :actions="estimate.estimate_actions" 
                      @action="actionClicked" />
      </MsgblContent>
    </template>

    <MsgblNoAccess v-else
                   icon="estimate"
                   :direction="message.direction">
    </MsgblNoAccess>
    
  </div>
</template>

<script>
import {
  BubbleHeader,
  BubbleTextRow,
  BubbleTextMsg,
  MsgblContent,
  MsgblLinkHeader,
  MsgblTextRow,
  MsgblNoAccess,
  MsgblTextLabel,
  MsgblTextValue,
  MsgblActions,
} from './helpers'
import { FrontageLink } from "@/modules/common/components"
import { itemizableService } from '@/modules/itemizable/services/itemizableService'
import { paymentsStatusesService } from "@/modules/payments/services";

export default {
  name: 'EstimateBubble',
  components: {
    BubbleHeader,
    BubbleTextRow,
    BubbleTextMsg,
    MsgblContent,
    MsgblLinkHeader,
    MsgblTextRow,
    MsgblNoAccess,
    MsgblTextLabel,
    MsgblTextValue,
    MsgblActions,
    FrontageLink,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    estimate() {
      return this.message.messageable
    },
  },
  methods: {
    async actionClicked({action}) {
      let data = {estimate: this.estimate, isEdit: action === 'edit'};
      if (action === 'view')
        return this.$frontageApi.navigateTo('app.estimate.show', {uid: this.estimate.uid});
      if (action === 'view_invoice')
        return this.$frontageApi.navigateTo('app.invoice.show', {uid: this.estimate.invoice_uid});
      if (this.$hasFeature('estimate_deposit') && ['approve', 'issue_invoice'].includes(action)){
        const res = await itemizableService.getDeposit({entity_uid: this.estimate.uid, entity_type: 'Estimate'});
        if (res.data.deposits.length === 1) { 
          const psRes = await paymentsStatusesService.get(res.data.deposits[0].payment_request_uid);
          if (action === 'approve') 
            action += '_and_take_payment';
          data.depositPS = psRes.data;
        }
      }
      this.$frontageApi.send('estimate-bubble-action', {action, data});
    },
  },
}
</script>